import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeItem: 'Dashboard',
}

const navSlice = createSlice({
  name: 'nav',
  initialState,
  reducers: {
    setActiveItem: (state, action) => {
      state.activeItem = action.payload
    },
  },
})

export const { setActiveItem } = navSlice.actions
export default navSlice.reducer
